import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const CHECKBOX_CONTROL_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CheckboxComponent),
  multi: true,
};

export enum CheckboxType {
  image = 'image',
  text = 'text',
}

@Component({
  selector: 'ife-checkbox',
  providers: [CHECKBOX_CONTROL_ACCESSOR],
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent implements OnInit, ControlValueAccessor {
  @Input() value: any;

  // Type of the checkbox (image or text), default is image
  @Input() type: CheckboxType = CheckboxType.image;

  // Content properties
  @Input() image: string;
  @Input() desktopImage: string;
  @Input() imageAltText: string;
  @Input() caption: string;

  readonly checkboxType = CheckboxType;
  public model: any;
  public onChange = (value: any) => {};
  public onTouched = () => {};

  ngOnInit(): void {
    // Use imageCaption as fallback for our image imageAltText
    if (this.caption && !this.imageAltText) {
      this.imageAltText = this.caption;
    }

    // Sets the width to switch to desktop image and checks if only 1 image is passed;
    if (this.desktopImage && !this.image) {
      this.image = this.desktopImage;
    }
    if (this.image && !this.desktopImage) {
      this.desktopImage = this.image;
    }

    this.desktopImage = this.desktopImage + ' 640w';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value: any) {
    this.model = value;
  }

  select() {
    this.model = this.value;
    this.onChange(this.model);
  }
}
